import { useI18nWithOut } from "@/lang";
import { transferOptionsToMapper } from "@/utils/tools";

const { t } = useI18nWithOut();

export const ICDocTypeEnum = {
  REGISTRATION_NO: "registration_no",
  IC_NO: "ic_no",
  PASSPORT_NO: "passport_no",
  MY_TENTERA_NO: "my_tentera_no",
};

export const getICDocTypeOptions = () => [
  { label: t("registrationNo"), value: ICDocTypeEnum.REGISTRATION_NO },
  { label: t("icNo"), value: ICDocTypeEnum.IC_NO },
  { label: t("passportNo"), value: ICDocTypeEnum.PASSPORT_NO },
  { label: t("myTenteraNo"), value: ICDocTypeEnum.MY_TENTERA_NO },
];

export const getICDocTypeMap = () =>
  transferOptionsToMapper(getICDocTypeOptions());

export const InvoiceStatusEnum = {
  UNDER_REVIEW: "under_review",
  INVOICED: "invoiced",
  VOIDED: "voided",
};

export const getInvoiceStatusTextMap = () => ({
  [InvoiceStatusEnum.UNDER_REVIEW]: t("processing"),
  [InvoiceStatusEnum.INVOICED]: t("invoiced"),
  [InvoiceStatusEnum.VOIDED]: t("cancelled"),
});
